import { APPCONFIG } from './config';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd } from '@angular/router';

import 'styles/material2-theme.scss';
import 'styles/bootstrap.scss';

import 'styles/layout.scss';
import 'styles/theme.scss';
import 'styles/ui.scss';
import 'styles/app.scss';

@Component({
  selector: 'app',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  
  AppConfig: any;  
  constructor(private router: Router, 
              private translate: TranslateService) {    
    let usuario = JSON.parse(localStorage.getItem('currentUserCobranca'));
    translate.setDefaultLang( usuario && usuario.language ? usuario.language : 'pt-BR');  
  }

  ngOnInit() {
    this.AppConfig = APPCONFIG;

    this.router.events.subscribe(evt => {
      if (!(evt instanceof NavigationEnd)) 
        return;
      
      document.body.scrollTop = 0;
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/app.component.ts